<template>
	<section class="d-flex h-100 w-100">


				<div v-if="isLoading" class="d-flex justify-content-center align-items-center w-100">
					<div class="d-flex spinner-border text-dark" role="status" />
				</div>

				<div v-else class="w-100">

						<h3 class="mt-3">
							{{formLabel}}
						</h3>

						<!-- BOX CONTAINER -->
						<div class="alert alert-light">
              <div v-if="isAnswered" class="text-center">

                <h3>Merci d'avoir pris le temps de répondre !</h3>
                <p class="question-hint">
                  Vous pouvez fermer cette fenêtre.
                </p>

              </div>
              <div v-else>

                <h4 class="question-label">Diriez-vous que vous êtes satisfait(e) de la solution Emotivi ?</h4>
                <p class="question-hint m-0">Donnez une note de 1 à 5 en cliquant sur une étoile.</p>


                  <star-rating v-model="userRating" :max-stars="5" @ratingData="updateRating" /> 
                  <div class="align-content-center">
                    {{ ratingStatus }}
                  </div>

                <h4 class="question-label mt-4">Recommanderiez-vous la solution Emotivi ?</h4>
                <p class="question-hint">Répondez par oui ou non.</p>

                <div class="form-check form-check-inline">
                  <input v-model="userRecommend" class="form-check-input" name="recommend" type="radio" id="reco_yes" value="1">
                  <label class="form-check-label" for="reco_yes">Oui</label>
                </div>
                <div class="form-check form-check-inline">
                  <input v-model="userRecommend" class="form-check-input" name="recommend" type="radio" id="reco_no" value="0">
                  <label class="form-check-label" for="reco_no">Non</label>
                </div>

                <h4 class="question-label mt-4">Souhaitez-vous témoignez de votre expérience ?</h4>
                <p class="question-hint">Décrivez en quelques mots ce qu'Emotivi a pu vous apporter.</p>       
                <textarea v-model="userTestimony" class="form-control" rows="6"></textarea>
              </div>
            </div>
            <div v-show="!isAnswered" class="text-end mb-3">
              <button class="btn btn-large btn-primary" @click="submitForm">Valider</button>
            </div>
        </div>

  </section>
</template>

<script>
import StarRating from "../components/StarRating.vue";

export default {
  name: "feedback",
  components: {
    StarRating,
  },
  data() {
    return {
			isLoading: false,
      isAnswered: false,
      formLabel: "",
      userRating: 0,
      ratingStatus: "",
      userRecommend: "",
      userTestimony: "",
    };
  },
  mounted() {
    this.loadData();
  },

  methods: {

    async loadData() {
  
			this.isLoading = true;
			let response = await this.$axios.get(`${this.$config.server_url}/web/2.0/extradata/${this.$route.params.token}`);
			this.isLoading = false;

			if(response.data.err) {

			} else {
        let data = response.data.data.ed_data;
			  this.formLabel = response.data.data.ed_label;
        this.userRating = data.rating.value;
        this.userRecommend = data.recommend.value;
        this.userTestimony = data.testimony.value;
			}	
    },

    updateRating(newRating) {
      // Handle the new rating as needed.
      this.userRating = newRating;
    },

    async submitForm() {

      let ed_data = {
        rating: {
          label: "Niveau de satisfaction",
          value: this.userRating,
        },
        recommend: {
          label: "Recommande Emotivi",
          value: this.userRecommend,
        },
        testimony: {
          label: "Témoignage",
          value: this.userTestimony
        }
      };

			let response = await this.$axios.put(`${this.$config.server_url}/web/2.0/extradata/${this.$route.params.token}`, { ed_data });

			this.isLoading = false;

			if(response.data.err) {

			} else {
        this.userRating = 0;
        this.userRecommend = "";
        this.userTestimony = "";
        this.isAnswered = true;
			}
    }
  },
  
  watch: {

    userRating(value) {
      switch(value){
        case 1:
          this.ratingStatus = "Très insatisfait(e)";
          break;
        case 2:
          this.ratingStatus = "Insatisfait(e)";
          break;
        case 3:
          this.ratingStatus = "Moyennement satisfait(e)";
          break;
        case 4:
          this.ratingStatus = "Satisfait(e)";
          break;
        case 5:
          this.ratingStatus = "Très satisfait(e)";
          break; 
        default:
          this.ratingStatus = "";
      }

    }
  }
};
</script>

<style lang="scss" scoped>
  .question-label {
    font-weight: 500;
  }

  .question-hint {
    color: #a0a0a0;
  }
</style>